// @flow

import { useEffect, useState } from 'react';

type UseDismissableResponse = [boolean, () => void];

export default function useDismissable(
  namespace?: string,
  key?: string
): UseDismissableResponse {
  const localStorageKey = namespace && key && `${namespace}/${key}`;

  const [dismissed, setDismissed] = useState(() => {
    if (localStorage && localStorageKey) {
      return localStorage.getItem(localStorageKey) === 'true';
    } else {
      return false;
    }
  });

  useEffect(() => {
    if (localStorageKey) {
      localStorage &&
        localStorage.setItem(localStorageKey, dismissed.toString());
    }
  }, [localStorageKey, dismissed]);

  const setAsDismissed = setDismissed.bind(this, true);
  return [dismissed, setAsDismissed];
}
